<template>
  <div :class="showMutirao ? 'main-home-itabuna' : 'main-home'">
    <AppMenu @docollapse="doCollapse"/>

    <div class="right_col content ease-all">
      <MenuUsageAlert @dismiss="handleAlertDismissed"/>
      <MenuStorageBar @click="toPlans()"/>
      <!-- <MenuUsageBar v-else/> -->

      <HomeHeader class="home-header-box" @docollapse="doCollapse"/>

      <HomeLimbo v-if="!session.currentClinic"/>

      <div class="main-content" :class="shouldShowUsageAlert ? 'has-alert' : 'has-usage-bar'" v-else>

        <router-view class="panel-content" @collapse-menu="doCollapse" v-if="isDataReady"/>
      </div>

      <teleport to="body">
        <AcceptanceTermsOffcanvas ref="acceptanceTermsOffcanvas"/>
        <AcceptanceWelcomeTipsOffcanvas ref="acceptanceWelcomeTipsOffcanvas"/>
        <BaseGenericOffcanvas :offcanvas_id="'offcanvasUserMfaGeneric'" ref="offcanvasGeneric"/>
        <PatientShowOffcanvas ref="patientShowOffcanvas" @change-patient="openAssignPatientOffcanvas"/>
      </teleport>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.main-home,
.main-home-itabuna {
  height:                               100vh;
}

.content {
  display:                              inline-block;
  // width:                                calc(100% - 230px);
  width:                                100%;
  float:                                right;

  > .storage-box,
  > .usage-bar {
    display:                            none;
  }

  .main-content {
    display:                            flex;
    flex-direction:                     column;
    flex:                               1;
    min-height:                         0;
  }

  &.full-width {
    width:                              100%;
    float:                              unset;
  }
}

.main {
  position:                             relative;
  width:                                100%;
  min-height:                           740px;
  &.full-height {
    height:                             100vh;
  }
  &.retract {
    .content {
      margin-top:                       0;
    }
    // .content, .right_col, .footer width: calc(100% - 55px) — handled by flex: 1 automatically
    .menu,
    .sidebar {
      display:                          none;
      // width:                            55px !important;
    }
    .title-box {
      width:                            calc(100% - 300px) !important;
    }
    // .tab-box .col-md-9 max-height: calc(100vh - 217px) — replaced by flex: 1
  }
}

.content,
.panel-content {
  position:                             relative;
}

.panel-content {
  flex:                                 1;
  display:                              flex;
  flex-direction:                       column;
  min-height:                           0;
}

.clinic-title {
  display:                              none;
}

.storage-info {
  @include                              border_radius(10px);
  position:                             relative;
  display:                              flex;
  justify-content:                      flex-start;
  align-items:                          center;
  padding:                              15px;
  margin:                               15px;
  border:                               1px solid $charcoal;
  img {
    margin-right:                       20px;
  }
  h6, p {
    color:                              $charcoal;
    font-weight:                        normal;
    line-height:                        1.2;
    margin:                             0;
  }
  .btn-close {
    position:                           absolute;
    right:                              5px;
    top:                                5px;
  }
}

@media (min-width: 992px) {
  .main-home,
  .main-home-itabuna {
    display:                            flex;
    overflow:                           hidden;
  }

  .content {
    flex:                               1;
    display:                            flex;
    flex-direction:                     column;
    overflow:                           hidden;
    float:                              unset;
    width:                              auto;
  }
}

.control-bo {
  position:                             absolute;
  right:                                10px;
  top:                                  10px;
  z-index:                              999999;
}

.fa-wifi {
  color:                                green;
  &.red {
    color:                              red;
  }
}

@media (max-width: 991px) {
  .main-home {
    height:                             100dvh;
  }

  .main-home,
  .main-home-itabuna,
  .menu,
  .sidebar {
    display:                            block !important;
  }

  .main {
    min-height:                         645px;

    .content,
    .right_col {
      float:                            unset;
      position:                         relative;

      > .storage-box,
      > .usage-bar {
        display:                        flex;
      }
    }

    .content,
    &.retract .content,
    .right_col,
    &.retract .right_col {
      width:                            100% !important;
      margin-left:                      0 !important;
      // margin-top:                       -10px;
    }
  }

  .panel-content {
    padding:                            0px;
  }

  .storage-info {
    h6 {
      font-size:                        1em;
    }

    p {
      font-size:                        0.8em;
    }
  }

  .main-home {
    padding:                            0;
    overflow-y:                         hidden;
  }

  .content {
    width:                              100%;
  }

  .home-header-box {
    display:                            none;
  }
}

@media screen and (min-width: 992px) and (max-width: 1090px) {
  .main:not(.retract) .home-header-box {
    :deep(header) {
      gap:                              0;

      .storage-box {
        margin:                         0;

        .progress-box {
          gap:                          4px;

          .progress {
            width:                      40px;
          }
        }
      }
    }
  }
}

// safari
@media not all and (min-resolution: .001dpcm) {
@supports (-webkit-appearance:none) and (not (stroke-color:transparent)) {
  @media (max-width: 767px) {
    .main.retract {
      .footer {
        width:                          100% !important;
      }
    }
  }
}}

@media not all and (min-resolution:.001dpcm) {
@supports (-webkit-appearance:none) and (stroke-color:transparent) {
  @media (max-width: 767px) {
    .main.retract {
      .footer {
        width:                          100% !important;
      }
    }
  }
}}
</style>

<script>
import { useUserStore } from '@/store/user'
import { useExamFilterStore } from '@/store/examFilter'
import { useSubscriptionStore } from '@/store/subscription'
import { setLocale } from '@vee-validate/i18n';

import HomeHeader from './HomeHeader.vue'
// import HomeFooter from './HomeFooter.vue'
import AppMenu from './menu/menu.vue'
import MenuStorageBar from './menu/MenuStorageBar.vue'
import MenuUsageAlert from './menu/MenuUsageAlert.vue'
// import MenuUsageBar from './menu/MenuUsageBar.vue'
import HomeLimbo from './HomeLimbo.vue'
import AcceptanceTermsOffcanvas from '@/components/AcceptanceTermsOffcanvas.vue'
import AcceptanceWelcomeTipsOffcanvas from './AcceptanceWelcomeTipsOffcanvas.vue'
import PatientShowOffcanvas from './patient/patient-show/PatientShowOffcanvas.vue'

const TAG = "[home]"
export default {
  name: 'Home',
  components: {
    HomeHeader,
    // HomeFooter,
    AppMenu,
    MenuStorageBar,
    MenuUsageAlert,
    // MenuUsageBar,
    HomeLimbo,
    AcceptanceTermsOffcanvas,
    AcceptanceWelcomeTipsOffcanvas,
    PatientShowOffcanvas
  },
  data: () => ({
    loading: false,
    isCustomRoute: false,
    collapse: false,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    clinic: null,
    features: null,
    state: false,
    value: 0,
    attention: null,
    sessionExpired: null,
    isLogin: true,
    isWebSocketConnected: false,
    currentRoutePath: null,
    viewportHeight: 0,
    isDataReady: false,
    showMutirao: false,
    isPaidService: false,
    subscriptionName: '',
    dismissedInSession: false,
  }),
  watch: {
    '$route.path'() {
      this.dismissedInSession = false;
    }
  },
  computed: {
    subscriptionStore() {
      return useSubscriptionStore();
    },
    percentageValue() {
      return this.subscriptionStore.clinicUsage?.percentage || 0;
    },
    shouldShowUsageAlert() {
      if (this.dismissedInSession)
        return false;

      const percentageValue = this.percentageValue;
      const path = this.$route.path;

      if (path === '/dashboard' || percentageValue < 70) return false;
      if (percentageValue >= 100) return true;

      if (percentageValue >= 70 && percentageValue < 90) {
        const hidden = localStorage.getItem('hideUsageAlert_70');
        return hidden !== 'true';
      }

      return true;
    }
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    userStore.incrementTipsCount(0)
    this.showMutirao = this.session.features.includes('mutirao')
    this.isPaidService = this.$utils.getIsPaidService()

    this.$watch(
      () => userStore.tipsCount,
      (newValue) => {
        if (newValue == 3)
          this.showWelcomeTipsOffcanvas()
      }
    );

    this.currentRoutePath = this.$route.path

    if (this.currentRoutePath != '/exam/') {
      const examFilterStore = useExamFilterStore();
      examFilterStore.reset()
    }

    if (this.session && this.session.currentClinic) {
      this.$i18n.locale = this.session.currentClinic.locale.toLowerCase();
      setLocale(this.$i18n.locale);
      console.log("[app] setting locale (from clinic):", this.session.currentClinic.locale)
    }

    if (!localStorage.getItem('user-theme')) {
      localStorage.setItem('user-theme', 'light-theme')
    }

    const showTerm = !this.session.collaborator.acceptedTerm && this.session.currentClinic.country == "BR"

    if (showTerm)
      this.openTermsOffcanvas()

    this.webSocketInitialization()
    this.checkMFA(this.session)
    this.doCollapse() // starting collapsed

    this.isDataReady = true

    this.emitter.on('open-patient-details', this.openPatientShowOffcanvas)
    this.emitter.on('patient-reassigned', this.refreshPatientShowOffcanvas)
  },
  beforeUnmount() {
    this.emitter.off('open-patient-details', this.openPatientShowOffcanvas)
    this.emitter.off('patient-reassigned', this.refreshPatientShowOffcanvas)
  },
  methods: {
    openPatientShowOffcanvas(options) {
      this.$refs.patientShowOffcanvas.show(options)
    },

    refreshPatientShowOffcanvas(updatedExam) {
      this.$refs.patientShowOffcanvas.refreshAfterReassign(updatedExam)
    },

    openAssignPatientOffcanvas(payload) {
      this.emitter.emit('open-assign-patient-offcanvas', payload)
    },

    async checkMFA(session) {
      const isBlockedByMFA = this.$security.isBlockedByMFA(session)
      if (!isBlockedByMFA)
        return

      const ok = await this.$refs.offcanvasGeneric.show({
        title: this.$i18n.t('mfa.securityAlertTitle'),
        text:  this.$i18n.t('mfa.securityAlertText'),
        okButton: this.$i18n.t('mfa.yes'),
        okButtonClass: 'btn-success',
        cancelButton: this.$i18n.t('mfa.no'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        this.$router.push(`/user/mfa/${this.session.user.id}`)
       //this.$router.push({name: 'user-show', params: {userID: this.session.user.id}})
      }
    },

    reload() {
      this.state = false;
      this.value++;
      this.$nextTick(() => this.state = true);
    },

    checkRoute() {
      return this.state ? this.$route.fullPath : [this.$route.fullPath, this.value.toString()]
    },

    webSocketInitialization() {
      console.log(`${TAG} webSocketInitialization()`)
      const io = this.$io
      this.isWebSocketConnected = io.socket.isConnected()

      // DON'T TOUCH, MAGIC -> avoid bogous io socket connection on initialization (notification/listen gets a 302 http status response)
      if (this.isWebSocketConnected) {
        io.socket.disconnect()
        io.socket.reconnect()
      }

      io.socket.on('connect', () => {
        this.isWebSocketConnected = true
        this.webSocketForNotifications()
      })

      io.socket.on('disconnect', () => {
        this.isWebSocketConnected = false
      })
    },

    webSocketForNotifications() {
      console.log(`${TAG} webSocketForNotifications() <<<<`)
      const io = this.$io

      for (let e of ['notification_listening', 'notification_event']) {
        console.log('[app] unlisten to ws event:', e)
        io.socket.off(e);
      }

      io.socket.get('/api/v2/eyercloud/clinic/notification/listen', function gotResponse(body, response) {
        console.log(`${TAG} notification/listen:`, body);
        // TODO REMOVE websocket connection magic... here we get a http status 302 on response... WHY?
        // can we just save when we get a 200 response and avoid calling socket.reconnect when hitting the navigator URL?
      })

      io.socket.on('notification_listening', function(data) {
        console.log(`${TAG} notification_listening`, data);
      })

      io.socket.on('notification_event', data => {
        this.$notificationService.createNewNotification(this, data)
      })
    },

    doLogin() {
      window.open('/', '_self');
    },

    doCollapse(value) {
      this.collapse = !this.collapse;

      if (this.collapse) {
        $('.main').addClass('retract')
      } else {
        $('.main').removeClass('retract')
      }
    },

    defineLocale(value) {
      this.$i18n.locale = value;
      window.VeeValidate.localize(value);
    },

    async openTermsOffcanvas() {
      const ok = await this.$refs.acceptanceTermsOffcanvas.show({
        okButton: this.$i18n.t('terms.accept'),
        okButtonClass: 'btn-success',
        cancelButton: this.$i18n.t('terms.close'),
        cancelButtonClass: 'btn-outline-secondary'
      })
      if (ok) {
        console.log('ok terms offcanvas', ok);
        // this.doDelete()
      }
    },

    async showWelcomeTipsOffcanvas() {
      const ok = await this.$refs.acceptanceWelcomeTipsOffcanvas.show()
      if (ok) {
        await this.$authService.refreshSession(this)
      }
    },

    handleAlertDismissed() {
      this.dismissedInSession = true;
    },

    toPlans() {
      this.$router.push('/plans/')
    },
  }
}
</script>
